import { render, staticRenderFns } from "./HerbSankeyChart.vue?vue&type=template&id=2015b463&scoped=true"
import script from "./HerbSankeyChart.vue?vue&type=script&lang=js"
export * from "./HerbSankeyChart.vue?vue&type=script&lang=js"
import style0 from "./HerbSankeyChart.vue?vue&type=style&index=0&id=2015b463&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2015b463",
  null
  
)

export default component.exports